module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": ""
    },
    on: {
      "click": _vm.hideBlock
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md9": "",
      "mt-5": "",
      "mb-5": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "mt-7",
    attrs: {
      "align": "center"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "profile-body"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "font-30 font-weight-bold",
    attrs: {
      "id": "postingTitle"
    }
  }, [_vm._v(_vm._s(_vm.posting.postingTitle))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "userDetail"
  }, [_c('div', {
    staticClass: "imgleft"
  }, [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "40"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.userDetail.userName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "headline white--text"
  }, [_vm._v("\n                              " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                            ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-side ml-2"
  }, [_c('a', {
    staticClass: "fw-bold font-18",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.userDetail.userName)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.userDetail.nickName) + "\n                            "), _c('span', [_vm._v("(" + _vm._s(_vm.userDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 font-16 fw-500"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('common.at')) + " " + _vm._s(_vm.dateFormat(_vm.posting.postingTime)) + "\n                          ")])])]), _vm._v(" "), _c('li', {
    staticClass: "right mr-5"
  }, [_c('v-speed-dial', {
    attrs: {
      "left": true,
      "direction": "left",
      "open-on-hover": true,
      "transition": "slide-x-reverse-transition"
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    staticClass: "share-icon",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": "",
      "fab": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("share")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "small": "",
      "dark": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:window.open('http://www.linkedin.com/sharing/share-offsite/?title='+encodeURIComponent(document.getElementById('postingTitle').innerHTML)+'&url='+encodeURIComponent(document.location.href),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');void(0)"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": _vm.$t('postingsel.linkedin'),
      "color": "white",
      "type": "social-twitter"
    }
  }, [_vm._v("mdi-linkedin")])], 1)]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "small": "",
      "dark": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(document.location.href)+'&t='+encodeURIComponent(document.title),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');void(0)"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": _vm.$t('postingsel.facebook'),
      "color": "white",
      "type": "social-facebook"
    }
  }, [_vm._v("mdi-facebook")])], 1)]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "small": "",
      "dark": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:window.open('http://twitter.com/home?status='+encodeURIComponent(document.getElementById('postingTitle').innerHTML)+''+encodeURIComponent(document.location.href)+''+encodeURIComponent('@IOB_llc'),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');void(0)"
    }
  }, [_c('v-icon', {
    attrs: {
      "title": _vm.$t('postingsel.twitter'),
      "color": "white",
      "type": "social-twitter"
    }
  }, [_vm._v("mdi-twitter")])], 1)])], 1)], 1)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": ""
    }
  }, [_c('v-card-text', {
    staticClass: "font-18",
    attrs: {
      "id": "posting-content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.posting.postingContent)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "d-custom-flex",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "font-14 mr-2 pa-2"
  }, [_vm._v(_vm._s(_vm.$t('postingsel.category')) + ": ")]), _vm._v(" "), _c('span', _vm._l((_vm.marketsList), function(market, index) {
    return (market.marketId == _vm.posting.marketId) ? _c('v-btn', {
      key: index,
      attrs: {
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.findByMarkets(market)
        }
      }
    }, [_vm._v(_vm._s(market.name))]) : _vm._e()
  }), 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "d-custom-flex",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.posting.tagList != null && _vm.posting.tagList.length > 0) ? _c('span', {
    staticClass: "font-14 mr-2 pa-2"
  }, [_vm._v(_vm._s(_vm.$t('postingsel.tags')) + ": ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._l((_vm.posting.tagList), function(postingtag, index) {
    return _c('v-btn', {
      key: index,
      attrs: {
        "outline": "",
        "small": "",
        "color": "primary darken-1"
      },
      on: {
        "click": function($event) {
          return _vm.findtagposting(postingtag.tagName)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(postingtag.tagName) + "\n                      ")])
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.getters.user != null && _vm.posting.postingUserId == this.$store.getters.user.userId),
      expression: "this.$store.getters.user != null && posting.postingUserId == this.$store.getters.user.userId"
    }],
    staticClass: "right",
    attrs: {
      "small": "",
      "color": "primary darken-1"
    },
    on: {
      "click": function($event) {
        return _vm.editPosting(_vm.posting)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('postingsel.edit')) + "\n                      ")])], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": ""
    }
  }, [_c('div', {
    staticClass: "font-14 ml-2"
  }, [_c('v-icon', {
    attrs: {
      "size": "20"
    }
  }, [_vm._v("schedule")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(_vm.posting.postingTime)) + " " + _vm._s(_vm.$t('common.by')))]), _vm._v(" "), _c('span', {
    staticClass: "Author"
  }, [_c('a', {
    staticClass: "font-16",
    attrs: {
      "id": "userinfo"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.userDetail.userName)
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.userDetail.nickName) + "\n                          "), _c('span', [_vm._v("(" + _vm._s(_vm.userDetail.reputationScore) + ")")])])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-30"
  }, [(_vm.posting.isOriginal) ? _c('span', {
    staticClass: "primary--text ml-2 font-14"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('postingsel.original')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.posting.isOriginal) ? _c('span', {
    staticClass: "pointer primary--text ml-2 font-14"
  }, [_c('a', {
    attrs: {
      "href": _vm.posting.originalLink,
      "target": "_black"
    }
  }, [_vm._v(_vm._s(_vm.$t('postingsel.source')))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "social-list clearfix right"
  }, [_c('ul', {
    staticClass: "list-inline d-inline-block"
  }, [_c('li', [(this.user != null && this.user.userName == 'Andy') ? _c('a', {
    staticClass: "font-1x mr-3",
    on: {
      "click": function($event) {
        return _vm.editPosting(_vm.posting)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('postingsel.edit')))]) : _vm._e()]), _vm._v(" "), _c('li', [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.bonus')
    }
  }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
    staticClass: "font-14"
  }, [_vm._v(_vm._s(_vm.posting.bonus != null ? _vm.posting.bonus.toFixed(2) : 0.0))])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingStatus == 0),
      expression: "posting.postingStatus == 0"
    }]
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary",
      "title": _vm.$t('posting.upvote')
    },
    on: {
      "click": _vm.changesup
    }
  }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v(" " + _vm._s(_vm.posting.postingGoodnums) + "\n                            "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getUpvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('postingsel.tread')
    },
    on: {
      "click": _vm.changesdown
    }
  }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v("\n                            " + _vm._s(_vm.posting.postingStepnums) + "\n                            "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getDownvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1)], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingStatus == 1),
      expression: "posting.postingStatus == 1"
    }]
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.upvote')
    },
    on: {
      "click": _vm.changesup
    }
  }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v(_vm._s(_vm.posting.postingGoodnums) + "\n                              "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getUpvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary",
      "title": _vm.$t('postingsel.tread')
    },
    on: {
      "click": _vm.changesdown
    }
  }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v("\n                              " + _vm._s(_vm.posting.postingStepnums) + "\n                              "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getDownvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1)], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingStatus == -1),
      expression: "posting.postingStatus == -1"
    }]
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.upvote')
    },
    on: {
      "click": _vm.changesup
    }
  }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v(_vm._s(_vm.posting.postingGoodnums) + "\n                            "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getUpvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('postingsel.tread')
    },
    on: {
      "click": _vm.changesdown
    }
  }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v("\n                            " + _vm._s(_vm.posting.postingStepnums) + "\n                            "), _c('v-icon', {
    staticClass: "fa-fort-down-icon",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.getDownvoteUser
    }
  }, [_vm._v("fas fa-sort-down")])], 1)], 1), _vm._v(" "), _c('li', [_c('v-icon', {
    staticClass: "poin",
    attrs: {
      "small": "",
      "title": _vm.$t('posting.comment')
    },
    on: {
      "click": _vm.commentsshow
    }
  }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v(_vm._s(_vm.posting.postingCountComments))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.retweet')
    },
    on: {
      "click": function($event) {
        return _vm.modalzf(_vm.posting)
      }
    }
  }, [_vm._v("fa fa-share")]), _vm._v(" "), _c('span', {
    staticClass: "font-14 ml-1"
  }, [_vm._v(_vm._s(_vm.posting.postingCountForword))])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingCollection == 0),
      expression: "posting.postingCollection == 0"
    }]
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary",
      "title": _vm.$t('posting.save')
    },
    on: {
      "click": _vm.collectionPosting
    }
  }, [_vm._v("fa fa-star")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingCollection != 0),
      expression: "posting.postingCollection != 0"
    }]
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "title": _vm.$t('posting.save')
    },
    on: {
      "click": _vm.collectionPosting
    }
  }, [_vm._v("fa fa-star")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUpvoteUserDiv),
      expression: "isShowUpvoteUserDiv"
    }],
    staticClass: "dropdown",
    attrs: {
      "id": "upvoteUserDiv"
    }
  }, [_vm._l((_vm.upvoteUserList), function(user) {
    return _c('div', [_c('div', {
      staticClass: "pointer font-14",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v("+ " + _vm._s(user.userName))])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingGoodnums > 20),
      expression: "posting.postingGoodnums > 20"
    }]
  }, [_c('div', {
    on: {
      "click": _vm.getUpvoteUser
    }
  }, [_vm._v("……")])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDownvoteUserDiv),
      expression: "isShowDownvoteUserDiv"
    }],
    staticClass: "dropdown ml-5"
  }, [_vm._l((_vm.downvoteUserList), function(user) {
    return _c('div', {
      staticClass: "dropdown_color"
    }, [_c('div', {
      staticClass: "pointer font-14",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v("+ " + _vm._s(user.userName))])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posting.postingGoodnums > 20),
      expression: "posting.postingGoodnums > 20"
    }]
  }, [_c('div', {
    on: {
      "click": _vm.getDownvoteUser
    }
  }, [_vm._v("……")])])], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.forwardModal),
      callback: function($$v) {
        _vm.forwardModal = $$v
      },
      expression: "forwardModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "font-30"
  }, [_vm._v(_vm._s(_vm.$t('posting.retweet')))])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-avatar', {
    staticClass: "pointer",
    attrs: {
      "color": "primary",
      "size": "40"
    },
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.userDetail.userName)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "white--text"
  }, [_vm._v("\n                                    " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                  ")])])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
    staticClass: "pointer font-18",
    on: {
      "click": function($event) {
        return _vm.goUserData(_vm.userDetail.nickName)
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.userDetail.nickName) + "\n                                    "), _c('span', [_vm._v("(" + _vm._s(_vm.userDetail.reputationScore) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "px-2 font-16"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('common.at')) + "\n                                    "), _c('v-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("schedule")]), _vm._v("\n                                    " + _vm._s(_vm.dateFormat(_vm.posting.postingTime)) + "\n                                  ")], 1)]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
    staticClass: "font-18"
  }, [_vm._v(_vm._s(_vm.posting.postingTitle))])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formValidatezf"
  }, [_c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4"
    },
    model: {
      value: (_vm.formValidatezf.postingForwardContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidatezf, "postingForwardContext", $$v)
      },
      expression: "formValidatezf.postingForwardContext"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.forwardModal = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.postingforward
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowcomments),
      expression: "isShowcomments"
    }],
    staticClass: "mt-5"
  }, [_c('v-form', {
    ref: "formValidate"
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    staticClass: "mt-3 postCommentOfEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "blur": function($event) {
        return _vm.onEditorBlur($event)
      },
      "focus": function($event) {
        return _vm.onEditorFocus($event)
      },
      "ready": function($event) {
        return _vm.onEditorReady($event)
      },
      "change": function($event) {
        return _vm.onEditorChange($event)
      }
    },
    model: {
      value: (_vm.formValidate.commentsContext),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "commentsContext", $$v)
      },
      expression: "formValidate.commentsContext"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.postingcomments('formValidate')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isShowcomments = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 mt-3"
  }, [_c('div', {
    staticClass: "border-bottom-light-1 pt-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingCommentList != null && _vm.postingCommentList.length > 0),
      expression: "postingCommentList != null && postingCommentList.length > 0"
    }],
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$t('postingsel.DISCUSSION')))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "comments"
    }
  }, _vm._l((_vm.postingCommentList), function(com, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (com.parentCommentId == null),
        expression: "com.parentCommentId == null"
      }],
      staticClass: "my-5",
      attrs: {
        "id": com.commentsId
      }
    }, [_c('span', {
      staticClass: "right pointer",
      on: {
        "click": function($event) {
          return _vm.commentsUporDown($event, com)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "title": _vm.$t('postingsel.UporDown'),
        "size": "20",
        "type": "chevron-down"
      }
    })], 1), _vm._v(" "), _vm._l((_vm.usercommentsList), function(commentuser, index) {
      return (com.commentsUserId == commentuser.userId) ? _c('dl', {
        staticClass: "font-14 d-custom-flex"
      }, [_c('dt', [_c('v-avatar', {
        staticClass: "pointer",
        attrs: {
          "color": "primary",
          "size": "32"
        },
        on: {
          "click": function($event) {
            return _vm.goUserData(commentuser.userName)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (commentuser.image != null),
          expression: "commentuser.image != null"
        }],
        attrs: {
          "src": commentuser.image,
          "alt": commentuser.userName
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (commentuser.image == null),
          expression: "commentuser.image == null"
        }],
        staticClass: "headline white--text"
      }, [_vm._v("\n                          " + _vm._s(commentuser.userName != null ? commentuser.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                        ")])])], 1), _vm._v(" "), _c('dd', {
        staticClass: "ml-2"
      }, [_c('span', {
        staticClass: "pointer font-16",
        on: {
          "click": function($event) {
            return _vm.goUserData(commentuser.userName)
          }
        }
      }, [_vm._v("\n                        " + _vm._s(commentuser.nickName) + "\n                        "), _c('span', [_vm._v("(" + _vm._s(commentuser.reputationScore) + ")")])]), _vm._v(" "), _c('span', [_vm._v("·")]), _vm._v(" "), _c('span', {
        staticClass: "font-14"
      }, [_vm._v(_vm._s(_vm.dateFormat(com.commentsTime)))]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (com.cupordown),
          expression: "com.cupordown"
        }]
      }, [(com.editCommentsFlag) ? _c('div', [_c('div', {
        staticClass: "font-14 mt-3",
        domProps: {
          "innerHTML": _vm._s(com.commentsContext)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "social-list mt-3"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.postingCommentsEvaluationList != null),
          expression: "postingCommentsEvaluationList != null"
        }]
      }, _vm._l((_vm.postingCommentsEvaluationList), function(pce, index) {
        return _c('ul', {
          key: index,
          staticClass: "list-inline d-inline-block"
        }, [_c('li', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (pce.commentsId == com.commentsId && pce.eStatus == 0),
            expression: "pce.commentsId == com.commentsId && pce.eStatus == 0"
          }]
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.bonus')
          }
        }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.bonus != null ? com.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "color": "primary",
            "title": _vm.$t('postingsel.upvote')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '0')
            }
          }
        }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('postingsel.tread')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '1')
            }
          }
        }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.comment')
          },
          on: {
            "click": function($event) {
              return _vm.changeData(com)
            }
          }
        }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.user != null && com.commentsUserId == _vm.user.userId),
            expression: "user != null && com.commentsUserId == user.userId"
          }],
          attrs: {
            "small": "",
            "title": _vm.$t('common.edit')
          },
          on: {
            "click": function($event) {
              return _vm.editComment(com)
            }
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (pce.commentsId == com.commentsId && pce.eStatus == 1),
            expression: "pce.commentsId == com.commentsId && pce.eStatus == 1"
          }]
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.bonus')
          }
        }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.bonus != null ? com.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('postingsel.upvote')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '0')
            }
          }
        }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "color": "primary",
            "title": _vm.$t('postingsel.tread')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '1')
            }
          }
        }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.comment')
          },
          on: {
            "click": function($event) {
              return _vm.changeData(com)
            }
          }
        }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.user != null && com.commentsUserId == _vm.user.userId),
            expression: "user != null && com.commentsUserId == user.userId"
          }],
          attrs: {
            "small": "",
            "title": _vm.$t('common.edit')
          },
          on: {
            "click": function($event) {
              return _vm.editComment(com)
            }
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (pce.commentsId == com.commentsId && pce.eStatus == -1),
            expression: "pce.commentsId == com.commentsId && pce.eStatus == -1"
          }]
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.bonus')
          }
        }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.bonus != null ? com.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('postingsel.upvote')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '0')
            }
          }
        }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('postingsel.tread')
          },
          on: {
            "click": function($event) {
              return _vm.evaluateComment(com.commentsId, '1')
            }
          }
        }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "title": _vm.$t('posting.comment')
          },
          on: {
            "click": function($event) {
              return _vm.changeData(com)
            }
          }
        }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
          staticClass: "font-14 ml-1"
        }, [_vm._v(_vm._s(com.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.user != null && com.commentsUserId == _vm.user.userId),
            expression: "user != null && com.commentsUserId == user.userId"
          }],
          attrs: {
            "small": "",
            "title": _vm.$t('common.edit')
          },
          on: {
            "click": function($event) {
              return _vm.editComment(com)
            }
          }
        }, [_vm._v("edit")])], 1)])
      }), 0), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.postingCommentsEvaluationList == null),
          expression: "postingCommentsEvaluationList == null"
        }]
      }, [_c('ul', {
        staticClass: "list-inline d-inline-block"
      }, [_c('li', [_c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.bonus')
        }
      }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(com.bonus != null ? com.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.upvote')
        },
        on: {
          "click": function($event) {
            return _vm.evaluateComment(com.commentsId, '0')
          }
        }
      }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(com.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('postingsel.tread')
        },
        on: {
          "click": function($event) {
            return _vm.evaluateComment(com.commentsId, '1')
          }
        }
      }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(com.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
        attrs: {
          "small": "",
          "title": _vm.$t('posting.comment')
        },
        on: {
          "click": function($event) {
            return _vm.changeData(com)
          }
        }
      }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(com.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.user != null && com.commentsUserId == _vm.user.userId),
          expression: "user != null && com.commentsUserId == user.userId"
        }],
        attrs: {
          "small": "",
          "title": _vm.$t('common.edit')
        },
        on: {
          "click": function($event) {
            return _vm.editComment(com)
          }
        }
      }, [_vm._v("edit")])], 1)])])]), _vm._v(" "), (com.cshow) ? _c('div', {
        staticClass: "postingreplys"
      }, [_c('v-form', {
        ref: "formValidatereply",
        refInFor: true
      }, [_c('v-text-field', {
        staticClass: "d-none",
        model: {
          value: (com.commentsId),
          callback: function($$v) {
            _vm.$set(com, "commentsId", $$v)
          },
          expression: "com.commentsId"
        }
      }), _vm._v(" "), _c('quill-editor', {
        ref: "myQuillEditor",
        refInFor: true,
        staticClass: "mt-3 postCommentOfEditor",
        on: {
          "blur": function($event) {
            return _vm.onEditorBlur($event)
          },
          "focus": function($event) {
            return _vm.onEditorFocus($event)
          },
          "ready": function($event) {
            return _vm.onEditorReady($event)
          },
          "change": function($event) {
            return _vm.onEditorChange($event)
          }
        },
        model: {
          value: (_vm.formValidatereply.commentsContext),
          callback: function($$v) {
            _vm.$set(_vm.formValidatereply, "commentsContext", $$v)
          },
          expression: "formValidatereply.commentsContext"
        }
      }), _vm._v(" "), _c('v-btn', {
        attrs: {
          "color": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.postingreplys('formValidatereply', com)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
        attrs: {
          "color": "primary",
          "type": "ghost"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.postingreplyclose(com)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1) : _vm._e()]) : _c('div', [_c('v-form', [_c('quill-editor', {
        ref: "myQuillEditor",
        refInFor: true,
        staticClass: "mt-3 postCommentOfEditor",
        on: {
          "blur": function($event) {
            return _vm.onEditorBlur($event)
          },
          "focus": function($event) {
            return _vm.onEditorFocus($event)
          },
          "ready": function($event) {
            return _vm.onEditorReady($event)
          },
          "change": function($event) {
            return _vm.onEditorChange($event)
          }
        },
        model: {
          value: (_vm.editCommentsContext),
          callback: function($$v) {
            _vm.editCommentsContext = $$v
          },
          expression: "editCommentsContext"
        }
      }), _vm._v(" "), _c('v-btn', {
        attrs: {
          "color": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.updateComment(com)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
        attrs: {
          "color": "primary",
          "type": "ghost"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            com.editCommentsFlag = !com.editCommentsFlag
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1), _vm._v(" "), _vm._l((com.postingCommentList), function(rep, index) {
        return (rep.parentCommentId != null) ? _c('div', {
          staticClass: "mt-5"
        }, [_c('span', {
          staticClass: "right pointer pos-absolute ml-71",
          on: {
            "click": function($event) {
              return _vm.commentsUporDown($event, rep)
            }
          }
        }, [_c('Icon', {
          attrs: {
            "size": "20",
            "title": _vm.$t('postingsel.UporDown'),
            "type": "chevron-down"
          }
        })], 1), _vm._v(" "), _vm._l((_vm.usercommentsList), function(commentuser1, index) {
          return (rep.commentsUserId == commentuser1.userId) ? _c('div', {
            staticStyle: {
              "display": "flex"
            }
          }, [_c('dt', [_c('v-avatar', {
            staticClass: "pointer",
            attrs: {
              "color": "primary",
              "size": "32"
            },
            on: {
              "click": function($event) {
                return _vm.goUserData(commentuser1.userName)
              }
            }
          }, [_c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (commentuser1.image != null),
              expression: "commentuser1.image != null"
            }],
            attrs: {
              "src": commentuser1.image,
              "alt": commentuser1.userName
            }
          }), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (commentuser1.image == null),
              expression: "commentuser1.image == null"
            }],
            staticClass: "white--text"
          }, [_vm._v("\n                                  " + _vm._s(commentuser1.userName != null ? commentuser1.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                ")])])], 1), _vm._v(" "), _c('dd', {
            staticClass: "ml-2"
          }, [_c('span', {
            staticClass: "pointer font-16",
            on: {
              "click": function($event) {
                return _vm.goUserData(commentuser1.userName)
              }
            }
          }, [_vm._v("\n                                " + _vm._s(commentuser1.nickName) + "\n                                "), _c('span', [_vm._v("(" + _vm._s(commentuser1.reputationScore) + ")")])]), _vm._v(" "), _c('span', [_vm._v("·")]), _vm._v(" "), _c('span', {
            staticClass: "font-14"
          }, [_vm._v(_vm._s(_vm.dateFormat(rep.commentsTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (rep.cupordown),
              expression: "rep.cupordown"
            }]
          }, [(rep.editCommentsFlag) ? _c('div', [_c('div', {
            staticClass: "font-14 mt-3",
            domProps: {
              "innerHTML": _vm._s(rep.commentsContext)
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "social-list mt-3"
          }, [_c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.postingCommentsEvaluationList != null),
              expression: "postingCommentsEvaluationList != null"
            }]
          }, _vm._l((_vm.postingCommentsEvaluationList), function(pce, index) {
            return _c('ul', {
              key: index,
              staticClass: "list-inline d-inline-block"
            }, [_c('li', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (pce.commentsId == rep.commentsId && pce.eStatus == 0),
                expression: "pce.commentsId == rep.commentsId && pce.eStatus == 0"
              }]
            }, [_c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.bonus')
              }
            }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
              staticClass: "font-14"
            }, [_vm._v(_vm._s(rep.bonus != null ? rep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "color": "primary",
                "title": _vm.$t('postingsel.upvote')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '0')
                }
              }
            }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('postingsel.tread')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '1')
                }
              }
            }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.comment')
              },
              on: {
                "click": function($event) {
                  return _vm.changeData(rep)
                }
              }
            }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.user != null && rep.commentsUserId == _vm.user.userId),
                expression: "user != null && rep.commentsUserId == user.userId"
              }],
              attrs: {
                "small": "",
                "title": _vm.$t('common.edit')
              },
              on: {
                "click": function($event) {
                  return _vm.editComment(rep)
                }
              }
            }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (pce.commentsId == rep.commentsId && pce.eStatus == 1),
                expression: "pce.commentsId == rep.commentsId && pce.eStatus == 1"
              }]
            }, [_c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.bonus')
              }
            }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
              staticClass: "font-14"
            }, [_vm._v(_vm._s(rep.bonus != null ? rep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('postingsel.upvote')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '0')
                }
              }
            }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "color": "primary",
                "title": _vm.$t('postingsel.tread')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '1')
                }
              }
            }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.comment')
              },
              on: {
                "click": function($event) {
                  return _vm.changeData(rep)
                }
              }
            }, [_vm._v("fa fa-comment")]), _vm._v("<\n                                          "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.user != null && rep.commentsUserId == _vm.user.userId),
                expression: "user != null && rep.commentsUserId == user.userId"
              }],
              attrs: {
                "small": "",
                "title": _vm.$t('common.edit')
              },
              on: {
                "click": function($event) {
                  return _vm.editComment(rep)
                }
              }
            }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (pce.commentsId == rep.commentsId && pce.eStatus == -1),
                expression: "pce.commentsId == rep.commentsId && pce.eStatus == -1"
              }]
            }, [_c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.bonus')
              }
            }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
              staticClass: "font-14"
            }, [_vm._v(_vm._s(rep.bonus != null ? rep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('postingsel.upvote')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '0')
                }
              }
            }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('postingsel.tread')
              },
              on: {
                "click": function($event) {
                  return _vm.evaluateComment(rep.commentsId, '1')
                }
              }
            }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": "",
                "title": _vm.$t('posting.comment')
              },
              on: {
                "click": function($event) {
                  return _vm.changeData(rep)
                }
              }
            }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
              staticClass: "font-14 ml-1"
            }, [_vm._v(_vm._s(rep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.user != null && rep.commentsUserId == _vm.user.userId),
                expression: "user != null && rep.commentsUserId == user.userId"
              }],
              attrs: {
                "small": "",
                "title": _vm.$t('common.edit')
              },
              on: {
                "click": function($event) {
                  return _vm.editComment(rep)
                }
              }
            }, [_vm._v("edit")])], 1)])
          }), 0), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.postingCommentsEvaluationList == null),
              expression: "postingCommentsEvaluationList == null"
            }]
          }, [_c('ul', {
            staticClass: "list-inline d-inline-block"
          }, [_c('li', [_c('v-icon', {
            attrs: {
              "small": "",
              "title": _vm.$t('posting.bonus')
            }
          }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
            staticClass: "font-14"
          }, [_vm._v(_vm._s(rep.bonus != null ? rep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
            attrs: {
              "small": "",
              "title": _vm.$t('postingsel.upvote')
            },
            on: {
              "click": function($event) {
                return _vm.evaluateComment(rep.commentsId, '0')
              }
            }
          }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
            staticClass: "font-14 ml-1"
          }, [_vm._v(_vm._s(rep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
            attrs: {
              "small": "",
              "title": _vm.$t('postingsel.tread')
            },
            on: {
              "click": function($event) {
                return _vm.evaluateComment(rep.commentsId, '1')
              }
            }
          }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
            staticClass: "font-14 ml-1"
          }, [_vm._v(_vm._s(rep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
            attrs: {
              "small": "",
              "title": _vm.$t('posting.comment')
            },
            on: {
              "click": function($event) {
                return _vm.changeData(rep)
              }
            }
          }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
            staticClass: "font-14 ml-1"
          }, [_vm._v(_vm._s(rep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.user != null && rep.commentsUserId == _vm.user.userId),
              expression: "user != null && rep.commentsUserId == user.userId"
            }],
            attrs: {
              "small": "",
              "title": _vm.$t('common.edit')
            },
            on: {
              "click": function($event) {
                return _vm.editComment(rep)
              }
            }
          }, [_vm._v("edit")])], 1)])])]), _vm._v(" "), (rep.cshow) ? _c('div', {
            staticClass: "postingreplys"
          }, [_c('v-form', {
            ref: "formValidatereply",
            refInFor: true
          }, [_c('v-text-field', {
            staticClass: "d-none",
            model: {
              value: (rep.commentsId),
              callback: function($$v) {
                _vm.$set(rep, "commentsId", $$v)
              },
              expression: "rep.commentsId"
            }
          }), _vm._v(" "), _c('quill-editor', {
            ref: "myQuillEditor",
            refInFor: true,
            staticClass: "mt-3 postCommentOfEditor",
            attrs: {
              "options": _vm.editorOption
            },
            on: {
              "blur": function($event) {
                return _vm.onEditorBlur($event)
              },
              "focus": function($event) {
                return _vm.onEditorFocus($event)
              },
              "ready": function($event) {
                return _vm.onEditorReady($event)
              },
              "change": function($event) {
                return _vm.onEditorChange($event)
              }
            },
            model: {
              value: (_vm.formValidatereply.commentsContext),
              callback: function($$v) {
                _vm.$set(_vm.formValidatereply, "commentsContext", $$v)
              },
              expression: "formValidatereply.commentsContext"
            }
          }), _vm._v(" "), _c('v-btn', {
            attrs: {
              "color": "primary"
            },
            on: {
              "click": function($event) {
                return _vm.postingreplys('formValidatereply', rep)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('postingcreate.Post')))]), _vm._v(" "), _c('v-btn', {
            attrs: {
              "color": "primary",
              "type": "ghost"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.postingreplyclose(rep)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1) : _vm._e()]) : _c('div', [_c('v-form', [_c('quill-editor', {
            ref: "myQuillEditor",
            refInFor: true,
            staticClass: "mt-3 postCommentOfEditor",
            on: {
              "blur": function($event) {
                return _vm.onEditorBlur($event)
              },
              "focus": function($event) {
                return _vm.onEditorFocus($event)
              },
              "ready": function($event) {
                return _vm.onEditorReady($event)
              },
              "change": function($event) {
                return _vm.onEditorChange($event)
              }
            },
            model: {
              value: (_vm.editCommentsContext),
              callback: function($$v) {
                _vm.editCommentsContext = $$v
              },
              expression: "editCommentsContext"
            }
          }), _vm._v(" "), _c('v-btn', {
            attrs: {
              "color": "primary"
            },
            on: {
              "click": function($event) {
                return _vm.updateComment(rep)
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
            attrs: {
              "color": "primary",
              "type": "ghost"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                rep.editCommentsFlag = !rep.editCommentsFlag
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1), _vm._v(" "), _vm._l((rep.postingCommentList), function(reptorep, index) {
            return _c('div', {
              staticClass: "mt-5"
            }, [_c('span', {
              staticClass: "pointer right pos-absolute ml-68",
              on: {
                "click": function($event) {
                  return _vm.commentsUporDown($event, reptorep)
                }
              }
            }, [_c('Icon', {
              attrs: {
                "title": _vm.$t('postingsel.UporDown'),
                "size": "20",
                "type": "chevron-down"
              }
            })], 1), _vm._v(" "), _vm._l((_vm.usercommentsList), function(commentuser2, index) {
              return (reptorep.commentsUserId == commentuser2.userId) ? _c('div', {
                staticClass: "d-custom-flex font-14"
              }, [_c('dt', [_c('v-avatar', {
                staticClass: "pointer",
                attrs: {
                  "color": "primary",
                  "size": "32"
                },
                on: {
                  "click": function($event) {
                    return _vm.goUserData(commentuser2.userName)
                  }
                }
              }, [_c('img', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (commentuser2.image != null),
                  expression: "commentuser2.image != null"
                }],
                attrs: {
                  "src": commentuser2.image,
                  "alt": commentuser2.userName
                }
              }), _vm._v(" "), _c('span', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (commentuser2.image == null),
                  expression: "commentuser2.image == null"
                }],
                staticClass: "white--text"
              }, [_vm._v("\n                                          " + _vm._s(commentuser2.userName != null ? commentuser2.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                        ")])])], 1), _vm._v(" "), _c('dd', {
                staticStyle: {
                  "margin-left": "10px"
                }
              }, [_c('span', {
                staticClass: "pointer font-16",
                on: {
                  "click": function($event) {
                    return _vm.goUserData(commentuser2.userName)
                  }
                }
              }, [_vm._v("\n                                        " + _vm._s(commentuser2.nickName) + "\n                                        "), _c('span', [_vm._v("(" + _vm._s(commentuser2.reputationScore) + ")")])]), _vm._v(" "), _c('span', [_vm._v("·")]), _vm._v(" "), _c('span', {
                staticClass: "font-14"
              }, [_vm._v(_vm._s(_vm.dateFormat(reptorep.commentsTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (reptorep.cupordown),
                  expression: "reptorep.cupordown"
                }]
              }, [(reptorep.editCommentsFlag) ? _c('div', [_c('div', {
                staticClass: "font-14 mt-3",
                domProps: {
                  "innerHTML": _vm._s(reptorep.commentsContext)
                }
              }), _vm._v(" "), _c('div', {
                staticClass: "social-list mt-3 mb-4"
              }, [_c('div', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (_vm.postingCommentsEvaluationList != null),
                  expression: "postingCommentsEvaluationList != null"
                }]
              }, _vm._l((_vm.postingCommentsEvaluationList), function(pce, index) {
                return _c('ul', {
                  key: index,
                  staticClass: "list-inline d-inline-block"
                }, [_c('li', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (pce.commentsId == reptorep.commentsId && pce.eStatus == 0),
                    expression: "pce.commentsId == reptorep.commentsId && pce.eStatus == 0"
                  }]
                }, [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.bonus')
                  }
                }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14"
                }, [_vm._v(_vm._s(reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "primary",
                    "title": _vm.$t('postingsel.upvote')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '0')
                    }
                  }
                }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('postingsel.tread')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '1')
                    }
                  }
                }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.comment')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.changereplytoreply(reptorep, commentuser2)
                    }
                  }
                }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (_vm.user != null && reptorep.commentsUserId == _vm.user.userId),
                    expression: "user != null && reptorep.commentsUserId == user.userId"
                  }],
                  attrs: {
                    "small": "",
                    "title": _vm.$t('common.edit')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.editComment(reptorep)
                    }
                  }
                }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (pce.commentsId == reptorep.commentsId && pce.eStatus == 1),
                    expression: "pce.commentsId == reptorep.commentsId && pce.eStatus == 1"
                  }]
                }, [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.bonus')
                  }
                }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14"
                }, [_vm._v(_vm._s(reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('postingsel.upvote')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '0')
                    }
                  }
                }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "primary",
                    "title": _vm.$t('postingsel.tread')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '1')
                    }
                  }
                }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.comment')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.changereplytoreply(reptorep, commentuser2)
                    }
                  }
                }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (_vm.user != null && reptorep.commentsUserId == _vm.user.userId),
                    expression: "user != null && reptorep.commentsUserId == user.userId"
                  }],
                  attrs: {
                    "small": "",
                    "title": _vm.$t('common.edit')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.editComment(reptorep)
                    }
                  }
                }, [_vm._v("edit")])], 1), _vm._v(" "), _c('li', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (pce.commentsId == reptorep.commentsId && pce.eStatus == -1),
                    expression: "pce.commentsId == reptorep.commentsId && pce.eStatus == -1"
                  }]
                }, [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.bonus')
                  }
                }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('postingsel.upvote')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '0')
                    }
                  }
                }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('postingsel.tread')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.evaluateComment(reptorep.commentsId, '1')
                    }
                  }
                }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
                  attrs: {
                    "small": "",
                    "title": _vm.$t('posting.comment')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.changereplytoreply(reptorep, commentuser2)
                    }
                  }
                }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
                  staticClass: "font-14 ml-1"
                }, [_vm._v(_vm._s(reptorep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (_vm.user != null && reptorep.commentsUserId == _vm.user.userId),
                    expression: "user != null && reptorep.commentsUserId == user.userId"
                  }],
                  attrs: {
                    "small": "",
                    "title": _vm.$t('common.edit')
                  },
                  on: {
                    "click": function($event) {
                      return _vm.editComment(reptorep)
                    }
                  }
                }, [_vm._v("edit")])], 1)])
              }), 0), _vm._v(" "), _c('div', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (_vm.postingCommentsEvaluationList == null),
                  expression: "postingCommentsEvaluationList == null"
                }]
              }, [_c('ul', {
                staticClass: "list-inline d-inline-block"
              }, [_c('li', [_c('v-icon', {
                attrs: {
                  "small": "",
                  "title": _vm.$t('posting.bonus')
                }
              }, [_vm._v("fas fa-dollar-sign")]), _vm._v(" "), _c('span', {
                staticClass: "font-14"
              }, [_vm._v(_vm._s(reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0))]), _vm._v(" "), _c('v-icon', {
                attrs: {
                  "small": "",
                  "title": _vm.$t('postingsel.upvote')
                },
                on: {
                  "click": function($event) {
                    return _vm.evaluateComment(reptorep.commentsId, '0')
                  }
                }
              }, [_vm._v("thumb_up_alt")]), _vm._v(" "), _c('span', {
                staticClass: "font-14 ml-1"
              }, [_vm._v(_vm._s(reptorep.postingCommentsGoodnums))]), _vm._v(" "), _c('v-icon', {
                attrs: {
                  "small": "",
                  "title": _vm.$t('postingsel.tread')
                },
                on: {
                  "click": function($event) {
                    return _vm.evaluateComment(reptorep.commentsId, '1')
                  }
                }
              }, [_vm._v("thumb_down_alt")]), _vm._v(" "), _c('span', {
                staticClass: "font-14 ml-1"
              }, [_vm._v(_vm._s(reptorep.postingCommentsStepnums))]), _vm._v(" "), _c('v-icon', {
                attrs: {
                  "small": "",
                  "title": _vm.$t('posting.comment')
                },
                on: {
                  "click": function($event) {
                    return _vm.changereplytoreply(reptorep, commentuser2)
                  }
                }
              }, [_vm._v("fa fa-comment")]), _vm._v(" "), _c('span', {
                staticClass: "font-14 ml-1"
              }, [_vm._v(_vm._s(reptorep.childCommentsNumber))]), _vm._v(" "), _c('v-icon', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (_vm.user != null && reptorep.commentsUserId == _vm.user.userId),
                  expression: "user != null && reptorep.commentsUserId == user.userId"
                }],
                attrs: {
                  "small": "",
                  "title": _vm.$t('common.edit')
                },
                on: {
                  "click": function($event) {
                    return _vm.editComment(reptorep)
                  }
                }
              }, [_vm._v("edit")])], 1)])])]), _vm._v(" "), (reptorep.cshow) ? _c('div', {
                staticClass: "postingreplys"
              }, [_c('v-form', {
                ref: "formValidatereplytoreply",
                refInFor: true
              }, [_c('v-text-field', {
                staticClass: "d-none",
                model: {
                  value: (rep.commentsId),
                  callback: function($$v) {
                    _vm.$set(rep, "commentsId", $$v)
                  },
                  expression: "rep.commentsId"
                }
              }), _vm._v(" "), _c('quill-editor', {
                ref: "myQuillEditor",
                refInFor: true,
                staticClass: "mt-3 postCommentOfEditor",
                attrs: {
                  "options": _vm.editorOption
                },
                on: {
                  "blur": function($event) {
                    return _vm.onEditorBlur($event)
                  },
                  "focus": function($event) {
                    return _vm.onEditorFocus($event)
                  },
                  "ready": function($event) {
                    return _vm.onEditorReady($event)
                  },
                  "change": function($event) {
                    return _vm.onEditorChange($event)
                  }
                },
                model: {
                  value: (_vm.formValidatereplytoreply.commentsContext),
                  callback: function($$v) {
                    _vm.$set(_vm.formValidatereplytoreply, "commentsContext", $$v)
                  },
                  expression: "formValidatereplytoreply.commentsContext"
                }
              }), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "color": "primary"
                },
                on: {
                  "click": function($event) {
                    return _vm.postingreplytoreplys('formValidatereplytoreply', rep)
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
                staticClass: "primary white--text",
                attrs: {
                  "color": "primary"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.postingreplyclose(reptorep)
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1) : _vm._e()]) : _c('div', [_c('v-form', [_c('quill-editor', {
                ref: "myQuillEditor",
                refInFor: true,
                staticClass: "mt-3 postCommentOfEditor",
                on: {
                  "blur": function($event) {
                    return _vm.onEditorBlur($event)
                  },
                  "focus": function($event) {
                    return _vm.onEditorFocus($event)
                  },
                  "ready": function($event) {
                    return _vm.onEditorReady($event)
                  },
                  "change": function($event) {
                    return _vm.onEditorChange($event)
                  }
                },
                model: {
                  value: (_vm.editCommentsContext),
                  callback: function($$v) {
                    _vm.editCommentsContext = $$v
                  },
                  expression: "editCommentsContext"
                }
              }), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "color": "primary"
                },
                on: {
                  "click": function($event) {
                    return _vm.updateComment(reptorep)
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "color": "primary",
                  "type": "ghost"
                },
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    reptorep.editCommentsFlag = !reptorep.editCommentsFlag
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1)], 1)])])]) : _vm._e()
            })], 2)
          })], 2)])]) : _vm._e()
        })], 2) : _vm._e()
      })], 2)])]) : _vm._e()
    })], 2)
  }), 0)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c7c2246"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/post/Post.vue
// module id = 463
// module chunks = 0